import { useEffect, useState } from 'react';

import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { Alert, AlertTitle, Typography } from '@mui/material';

import { useAuthContext } from 'context/AuthContext';
import { useBreakpoints } from 'hooks/useBreakpoints';

const formatTimeRemaining = (totalSeconds: number) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

export function MenuSystemSessionAlert() {
    const { sessionState } = useAuthContext();
    const { isDownMd } = useBreakpoints();
    const [remainingSeconds, setRemainingSeconds] = useState<number | null>(null);

    const isSessionEnding = sessionState.status === 'ending';

    const updateRemainingSeconds = () => {
        const expirationTime = sessionState.expirationTimestamp || Date.now();
        const diff = Math.max(0, Math.floor((expirationTime - Date.now()) / 1000));

        setRemainingSeconds(diff);
    };

    const createSessionCounterInterval = () => {
        if (!isSessionEnding) {
            setRemainingSeconds(null);

            return;
        }

        updateRemainingSeconds();

        const intervalId = setInterval(updateRemainingSeconds, 1000);

        return () => clearInterval(intervalId);
    };

    useEffect(createSessionCounterInterval, [isSessionEnding, sessionState.expirationTimestamp]);

    if (!isSessionEnding) return null;

    return (
        <Alert
            severity="warning"
            icon={<AccessTimeOutlinedIcon />}
            onClick={(e) => e.stopPropagation()}
            sx={{
                'm': isDownMd ? 0 : 1,
                'borderRadius': 1.5,
                '& .MuiAlert-icon': { alignItems: 'center' },
            }}
        >
            <AlertTitle sx={{ fontWeight: 700, mb: 0.25 }}>Sessão expira em {formatTimeRemaining(remainingSeconds ?? 0)}</AlertTitle>

            <Typography variant="body2" color="warning.dark">
                Salve seus dados e conclua suas atividades.
            </Typography>
        </Alert>
    );
}
